// extracted by mini-css-extract-plugin
export default {"title":"HorizontalCardField_title__tZXO9"};